<template>
  <div
    v-if="price || priceMonthly"
    class="prices-container"
  >
    <Prices
      v-if="price"
      :is-price="price"
      :was-price="wasPrice"
      :is-price-bold="isPriceBold"
      :show-highlight="showHighlight"
      :pre-text-is-price="preTextIsPrice"
      :pre-text-was-price="preTextWasPrice"
      :post-text-is-price="priceMonthly && !wasPrice ? 'einmalig' : ''"
      :post-text-was-price="priceMonthly && wasPrice ? 'einmalig' : ''"
      :variant="variant"
      :theme="theme"
    >
      <template
        v-if="hasFootnote"
        #footnote
      >
        <LegalModalButton :texts="cleanTexts" />
      </template>
    </Prices>
    <Prices
      v-if="priceMonthly"
      :is-price="priceMonthly"
      :was-price="wasPriceMonthly"
      pre-text-is-price=""
      pre-text-was-price=""
      :show-highlight="showHighlight"
      :post-text-is-price="wasPriceMonthly ? '' : 'monatlich'"
      :post-text-was-price="wasPriceMonthly ? 'monatlich' : ''"
      :variant="variant"
      :theme="theme"
    >
      <template
        v-if="hasFootnote && !price"
        #footnote
      >
        <LegalModalButton :texts="cleanTexts" />
      </template>
    </Prices>
  </div>
</template>

<script setup lang="ts">
import { getPriceFormatted } from '~/lib/price-from-offer';
import { Prices } from '@i22team/td-longtail-vue-components';
import LegalModalButton from '~/components/legal-modal-button.vue';
import type { Maybe, Price } from '#shared/types/goliath/goliath.types';

export type PricesContainerProps = {
  pricesData?: (Price | Maybe<Price>)[] | undefined;
  legalTexts?: (string | null | undefined)[] | null;
  variant?: 'small' | 'medium' | 'large';
  preTextIsPrice?: string;
  preTextWasPrice?: string;
  isPriceBold?: boolean;
  theme?: 'light' | 'dark';
  showHighlight?: boolean;
};

const props = withDefaults(defineProps<PricesContainerProps>(), {
  pricesData: undefined,
  variant: 'large',
  preTextWasPrice: 'statt',
  theme: 'dark',
  legalTexts: undefined,
  preTextIsPrice: undefined,
});
const price = computed(() => getPriceFormatted(props.pricesData ?? [], 'DEFAULT', 'ONETIME'));

const wasPrice = computed(() => getPriceFormatted(props.pricesData ?? [], 'WAS', 'ONETIME'));
const priceMonthly = computed(() =>
  getPriceFormatted(props.pricesData ?? [], 'DEFAULT', 'MONTHLY')
);
const wasPriceMonthly = computed(() => getPriceFormatted(props.pricesData ?? [], 'WAS', 'MONTHLY'));
const cleanTexts = computed(
  () => props.legalTexts?.filter((t) => t !== null && t !== undefined) ?? []
);
const hasFootnote = computed(() => cleanTexts.value.length > 0);

defineExpose({ price, wasPrice });
</script>

<style lang="scss" scoped>
.prices-container {
  padding-bottom: 0;
  :deep(.legal-modal-button) {
    font-size: 1.5em;
    top: 0;
    align-self: flex-start;
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
